import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPersonQueryVariables = Types.Exact<{
  input: Types.GetPersonInput;
}>;

export type GetPersonQuery = {
  __typename?: 'Query';
  getPerson: {
    __typename?: 'GetPersonResponse';
    additionalRoles?: string | null;
    avatar?: string | null;
    createdAt: string;
    email: string;
    eventRole?: string | null;
    firstName: string;
    lastActiveAt: string;
    lastName: string;
    licenseNumber?: string | null;
    note?: string | null;
    organizationName?: string | null;
    phone?: string | null;
    policyCoverage?: string | null;
    relevantCertifications?: string | null;
    updatedAt: string;
    uuid: string;
    customizations?: Array<{
      __typename?: 'GetPersonResponsePersonCustomization';
      dateValue?: string | null;
      description?: string | null;
      name: string;
      textValue?: string | null;
      type: string;
      uuid: string;
    }> | null;
    role?: {
      __typename?: 'GetPersonResponsePersonRole';
      name: string;
      uuid: string;
      scope?: string | null;
    } | null;
    status: {
      __typename?: 'GetPersonResponsePersonStatus';
      name: string;
      uuid: string;
    };
    clientGroups: Array<{
      __typename?: 'GetPersonResponseClientGroup';
      uuid: string;
      name: string;
      address: string;
    }>;
    organizations: Array<{
      __typename?: 'GetPersonResponseOrganization';
      uuid: string;
      name: string;
      address: string;
      contactPerson?: string | null;
    }>;
  };
};

export const GetPersonDocument = gql`
  query GetPerson($input: GetPersonInput!) {
    getPerson(input: $input) {
      additionalRoles
      avatar
      createdAt
      customizations {
        dateValue
        description
        name
        textValue
        type
        uuid
      }
      email
      eventRole
      firstName
      lastActiveAt
      lastName
      licenseNumber
      note
      organizationName
      phone
      policyCoverage
      relevantCertifications
      role {
        name
        uuid
        scope
      }
      status {
        name
        uuid
      }
      updatedAt
      uuid
      clientGroups {
        uuid
        name
        address
      }
      organizations {
        uuid
        name
        address
        contactPerson
      }
    }
  }
`;
export function useGetPersonQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPersonQuery,
    GetPersonQueryVariables
  > &
    (
      | { variables: GetPersonQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPersonQuery, GetPersonQueryVariables>(
    GetPersonDocument,
    options,
  );
}
export function useGetPersonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonQuery,
    GetPersonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPersonQuery, GetPersonQueryVariables>(
    GetPersonDocument,
    options,
  );
}
export function useGetPersonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPersonQuery, GetPersonQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPersonQuery, GetPersonQueryVariables>(
    GetPersonDocument,
    options,
  );
}
export type GetPersonQueryHookResult = ReturnType<typeof useGetPersonQuery>;
export type GetPersonLazyQueryHookResult = ReturnType<
  typeof useGetPersonLazyQuery
>;
export type GetPersonSuspenseQueryHookResult = ReturnType<
  typeof useGetPersonSuspenseQuery
>;
export type GetPersonQueryResult = Apollo.QueryResult<
  GetPersonQuery,
  GetPersonQueryVariables
>;
export function refetchGetPersonQuery(variables: GetPersonQueryVariables) {
  return { query: GetPersonDocument, variables: variables };
}
